import { render } from "./LoadingButton.vue?vue&type=template&id=45e246e2&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=ts"
export * from "./LoadingButton.vue?vue&type=script&lang=ts"

import "./LoadingButton.vue?vue&type=style&index=0&id=45e246e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45e246e2"

export default script